// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"0231836e","453":"106b8a4a","455":"930a5a3e","977":"cda83fdf"}[chunkId] + ".chunk.js";
};